import { ChangeDetectionStrategy, Component, Input, OnChanges, inject } from '@angular/core';
import {
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow
} from '@angular/material/table';
import { QaReviewReliabilitySummaryColumn, QaReviewReliabilitySummaryViewRecord } from './qa-reviewer-reliability-report-summary.model';
import { QaReviewerReliabilitySummaryRecord } from '@src/app/features/reports/components/report-filters/models/report-data.model';
import { TableStructure } from '@/src/app/shared/components/table/models/table-structure.model';
import { ReportUtilsService } from '@src/app/features/reports/components/report-filters/services/report-utils.service';
import { EmptyTableStateComponent } from '@shared/components/empty-table-state/empty-table-state.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'stx-qa-reviewer-reliability-report-summary',
  templateUrl: './qa-reviewer-reliability-report-summary.component.html',
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    EmptyTableStateComponent
  ]
})
export class QaReviewerReliabilityReportSummaryComponent implements OnChanges {
  private reportUtilsService = inject(ReportUtilsService);

  private static readonly percentageColumns: QaReviewReliabilitySummaryColumn[] = ['accuracy'];

  @Input() summaryPage: TableStructure<QaReviewerReliabilitySummaryRecord>;

  columns: Array<keyof QaReviewerReliabilitySummaryRecord> = [];
  headers: Record<string, string> = {};
  records: QaReviewReliabilitySummaryViewRecord[] = [];

  ngOnChanges() {
    this.prepareTable();
  }

  private prepareTable() {
    this.headers = this.reportUtilsService.getPageHeaders({
      columns: this.summaryPage.labels
    });
    this.columns = this.reportUtilsService.getColumnsList(this.summaryPage.labels);
    this.records = this.summaryPage.data.content.map(record =>
      this.reportUtilsService.formatRecordNumericColumns<QaReviewReliabilitySummaryViewRecord>({
        record,
        columns: QaReviewerReliabilityReportSummaryComponent.percentageColumns,
        postfix: '%',
        precision: 0
      })
    );
  }
}
